import { useStaticQuery, graphql } from 'gatsby';
import transformer from 'src/transformers/ServiceQuery_Service';
import isNotNull from 'types/guards/isNotNull';

const useAllServices = (): typeof normalizedData => {
  const queryData = useStaticQuery<GatsbyTypes.ServicesForServicesBlockQuery>(graphql`
    query ServicesForServicesBlock {
      allWpService(sort: {order: ASC, fields: menuOrder}) {
        nodes {
          ...ServiceWithThumbnail
        }
      }
    }
  `);
  const normalizedData = queryData.allWpService.nodes
    .map((item) => transformer(item))
    .filter(isNotNull);
  return normalizedData;
};

export default useAllServices;
